import { Effect } from 'effect';

import { OrderToken } from '../../service/orderToken/OrderToken';

export const removeOrderToken = Effect.gen(function* () {
  const orderTokenService = yield* OrderToken;
  yield* orderTokenService.removeToken;
});
